import axios from "axios";
import JwtDecode from "jwt-decode";
import AxiosClient from "../../Network/AxiosClient";

export const signInFromOTP = (response) => {
  return (dispatch, getState) => {
    // const verifyCaptcha = axios.post(
    //   `${process.env.REACT_APP_API_URL}/api/auth/verify-captcha`,
    //   {
    //     rtoken: rtoken,
    //   }
    // );

    dispatch({
      type: "LOGGING_IN",
    });

    const token = response.data.access;
    const refresh = response.data.refresh;
    const portal = response.data.portal;

    //console.log(responses[0]);

    if (true) {
      localStorage.setItem("currUserToken", JSON.stringify(token));
      localStorage.setItem("accessRefreshToken", JSON.stringify(refresh));
      localStorage.setItem("portal", JSON.stringify(portal));

      if (portal === "dexter") {
        AxiosClient.get(
          `${process.env.REACT_APP_API_URL}/api/users/api/v1/details`,
          {
            headers: { Authorization: "Bearer " + token },
          }
        )
          .then((res) => {
            localStorage.setItem(
              "currUserType",
              JSON.stringify(res.data.user_type)
            );
            localStorage.setItem(
              "currManagerType",
              JSON.stringify(res.data.user_category)
            );

            localStorage.setItem("scope", res.data.scope);
            localStorage.setItem("name", JSON.stringify(res.data.username));
            localStorage.setItem("alias", JSON.stringify(res.data.name));
            localStorage.setItem("user_id", JSON.stringify(res.data.user_id));

            const type = JSON.parse(localStorage.getItem("currUserType"));
            const expiration = JwtDecode(token).exp;
            const status = res.status;
            const message = res.data;

            dispatch({
              type: "LOGIN_SUCCESS",
              auth: {
                token,
                refresh,
                expiration,
                type,
                portal,
                status,
                message,
              },
            });
          })
          .catch((err) => {
            const regex = /\d+/g;
            let message = "";
            let matches = null;

            if (err.response.status.toString() === "429") {
              message = err.response.data.detail;
              matches = message.match(regex);
            } else {
              message = err.response.data.message;
            }

            dispatch({
              type: "LOGIN_ERROR",
              err: {
                status: err.response.status,
                message,
                freeze: matches,
              },
            });
            localStorage.removeItem("currUserToken");
            localStorage.removeItem("accessRefreshToken");
            localStorage.removeItem("portal");
          });
      }
    }
  };
};
